import { render, staticRenderFns } from "./AreaForm.vue?vue&type=template&id=50a6e2d4&"
import script from "./AreaForm.vue?vue&type=script&lang=js&"
export * from "./AreaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports